import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UploadAtendimentoService {
  API = environment.API;

  
  
  constructor(private http: HttpClient) {
    environment.emitAPI.subscribe(api => {
      this.API = api
    })
  }
  
  public EnviarArquivo(objeto: any): Promise<any> {
    return this.http.post(`${this.API}AnexoTarefa`, objeto).toPromise();
  }
  
  public DeletarArquivo(objeto: any): Promise<any> {
    return this.http.delete(`${this.API}AnexoTarefa/${objeto.Id}/${objeto.PathArquivo}`).toPromise();
  }

  public ReceberArquivo(pathArquivo: string): Promise<any> {
    return this.http.get(`${this.API}AnexoTarefa/${pathArquivo}`, {responseType: 'arraybuffer'}).toPromise();
  }


}
